// extracted by mini-css-extract-plugin
export default {"wrap":"BM-z","articleImagesWrap":"CM-z","articleImage":"DM-z","singleImage":"EM-z"};